import React, { useContext, useEffect, useState } from "react";
import "./Newknowledge.scss";

// images
import crossIcon from "../../../../../assets/icons/cancelicon.svg";
import uploadIcon from "../../../../../assets/icons/upload.svg";
import KnowledgeBaseList from "../../KnowledgeBaseList/KnowledgeBaseList";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { SharedDataContext } from "../../KnowledgeBasis";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Newknowledge = () => {
  const { sharedData, setSharedData } = useContext(SharedDataContext);

  const [knowledgeBaseList, setknowledgeBaseList] = useState("");
  const [knowledgeAgentName, setKnowledgeAgentName] = useState(null);
  const [currentlyCreatedAgent, setCurrentlyCreatedAgent] = useState(null);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState(null);
  const [loadingForLoader, setLoadingForLoader] = useState(false);

  const [allKnowledgeAgents, setAllKnowledgeAgents] = useState(null);

  const [requriedAlert, setRequriedAlert] = useState("");

  const navigate = useNavigate();
  var authToken = JSON.parse(localStorage.getItem("bearerToken"));

  const handleknowledgeBaseList = (tab) => {
    setknowledgeBaseList(tab);
  };

  useEffect(() => {
    getAllAgent();
  }, []);

  const getAllAgent = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/customer/knowledge-agent`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log(data);
      setAllKnowledgeAgents(data.knowledgeAgents);
      console.log(data);
    } catch (error) {
      console.error("Error fetching agent:", error);
    }
  };

  const handleManuallyAddFaq = async () => {
    if (question != "" && answer && currentlyCreatedAgent) {
      try {
        await fetch(`${process.env.REACT_APP_API_URL}/customer/question-answer/${currentlyCreatedAgent._id}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({
            question,
            answer,
          }),
        })
          .then((data) => {
            console.log("FAQ :", data);
            setSharedData({ knowledgeId: currentlyCreatedAgent._id });
          })
          .catch((error) => console.error(error))
          .finally(() => {
            handleknowledgeBaseList("knowledgeBaseList");
          });
      } catch (error) {
        console.error("Error:", error.message);
      }
    }
  };

  const CreateKnowledgeAgent = async () => {
    try {
      if (!knowledgeAgentName.trim()) {
        toast.error("Please Enter Name");
        return;
      }

      const response = await fetch(`${process.env.REACT_APP_API_URL}/customer/create-knowledge`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          name: knowledgeAgentName,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to create knowledge agent');
      }

      const data = await response.json();
      console.log(data);

      setShowInput(true);
      setCurrentlyCreatedAgent(data);

    } catch (error) {
      console.error(error);
    }
  };


  const handleDeleteKnowledgebase = async (agentId) => {
    setLoadingForLoader(true);
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/knowledge-agent/${agentId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        getAllAgent();
        setLoadingForLoader(false);
      })
      .catch((error) => {
        setLoadingForLoader(false);
        console.log(error);
      });
  };

  // console.log("currentagent", currentlyCreatedAgent);

  // drag state
  const [dragActive, setDragActive] = React.useState(false);
  const inputRef = React.useRef(null);

  // handle drag events
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };
  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
    }
  };

  const handleChange = function (e) {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
      const fileType = selectedFile.type;

      // Check if the file type is CSV
      if (fileType === 'text/csv' || fileType === 'application/vnd.ms-excel') {
        // Process the CSV file
        console.log('CSV file selected:', selectedFile.name);

        // You can add your CSV file handling logic here
      } else {
        // Display an error message or take appropriate action for non-CSV files
        alert('Please select a CSV file.');
        // Clear the input field if needed
        e.target.value = '';
      }
    }
  };
  const [inputValue, setInputValue] = useState("");
  const [data, setData] = useState([]);
  const [showInput, setShowInput] = useState(false);

  const handleShowInput = () => {
    setShowInput(true);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleAddData = () => {
    if (inputValue.trim() !== "") {
      setData([...data, inputValue]);
      setInputValue("");
    }
  };

  const handleTableDelete = (index) => {
    const newData = [...data];
    newData.splice(index, 1);
    setData(newData);
  };

  return (
    <div>
      {knowledgeBaseList === "knowledgeBaseList" ? (
        <KnowledgeBaseList />
      ) : (
        <div className="NewKnowledge-main-container">
          <h5>Create a new knowledge base</h5>
          <h6>Create a new knowledge base for Landev AI to answer questions for you</h6>
          <div className="form">
            {!showInput ? (
              <></>
            ) : (
              <div className="NewKnowledge-head-option d-flex justify-content-between align-items-center">
                <span className="NewKnowledge-add-span">Add to Knowledge Base</span>
                <span className="d-flex justify-content-between align-items-center">
                  <input type="radio" name="knowledgeAddMethod" checked />
                  <label htmlFor="manualFAQ" className="mt-1">
                    Manually add FAQ flashcard
                  </label>
                </span>
                <span className="d-flex justify-content-between align-items-center">
                  {/* <input type="radio" name="knowledgeAddMethod" /> */}
                  <input type="radio" name="knowledgeAddMethod" class="" data-toggle="modal" data-target="#exampleModal" />

                  <label htmlFor="uploadDocuments" className="mt-1">
                    Upload documents
                  </label>
                  {/* Modal Area Start */}
                  <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">
                            <img className="closeButton" src={crossIcon} alt="" />
                          </span>
                        </button>
                        <div class="modal-body">
                          <h5>Upload Documents</h5>
                          <p>Upload documents and Landev AI will use AI to magically turn them into FAQ cards</p>

                          <section id="form-file-upload">
                            <input ref={inputRef} type="file" id="input-file-upload" multiple={true} onChange={handleChange} />
                            <label id="label-file-upload" htmlFor="input-file-upload">
                              <div>
                                <img className="mb-3" src={uploadIcon} alt="" />
                                <p className="upload-text">Click to upload files from computer</p>
                                <p className="upload-text2">or drag and drop here</p>
                                {/* <button className="upload-button" onClick={onButtonClick}>or drag and drop here</button> */}
                                {/* <button className="upload-button">or drag and drop here</button> */}
                              </div>
                            </label>
                            {dragActive && <div id="drag-file-element" onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div>}
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Modal Area End */}
                </span>
              </div>
            )}

            {!showInput ? (
              <>
                <span className="label-spans">
                  <label htmlFor="">Name</label>
                  <br />
                  <input type="text" value={knowledgeAgentName} onChange={(e) => {
                    setKnowledgeAgentName(e.target.value);
                  }} placeholder="eg. Support Knowledge Base" />
                  {/* <input type="text" value={inputValue} onChange={handleInputChange} placeholder="eg. Support Knowledge Base" /> */}
                  <p style={{ color: "#de3434", fontSize: "14px", fontWeight: "500" }}>{requriedAlert}</p>
                </span>
                <br />
                <div className="d-flex justify-content-end align-items-end">
                  {/* <button
                    className="themebtn-1 create-btn"
                    onClick={() => {
                      if (inputValue.trim() !== "") {
                        handleShowInput();
                        handleAddData();
                      } else {
                        setRequriedAlert("Please Enter Name");
                      }
                    }}
                  >
                    Create
                  </button> */}
                  <button className="themebtn-1 create-btn" onClick={CreateKnowledgeAgent}>
                    Create
                  </button>
                </div>
              </>
            ) : (
              <>
                <span className="label-spans">
                  <label htmlFor="">Question/Objection</label>
                  <br />
                  <input type="text" value={question} onChange={(e) => setQuestion(e.target.value)} placeholder="eg. What’s the name of your company?" />
                </span>
                <br />
                <span className="label-spans">
                  <label htmlFor="">Answers/Response</label>
                  <br />
                  <textarea name="" id="" cols="20" rows="8" placeholder="eg. Group Landev" value={answer} onChange={(e) => setAnswer(e.target.value)} />
                </span>
                <div className="d-flex justify-content-end align-items-end">
                  {/* <button className="themebtn-1 create-btn" onClick={() => handleknowledgeBaseList("knowledgeBaseList")}> */}
                  <button className="themebtn-1 create-btn" onClick={handleManuallyAddFaq}>
                    Create
                  </button>
                </div>
              </>
            )}
          </div>
          {/* Tabel */}
          {!showInput ? (
            <></>
          ) : (
            <div className="KnowledgeBaseTable-main-container">
              {/* <h2>Data Table</h2> */}
              <table>
                <thead>
                  <tr>
                    <th className="number-column">#</th>
                    <th>Name</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {allKnowledgeAgents &&
                    allKnowledgeAgents.map((item, index) => (
                      <tr
                        key={item._id}
                        onClick={async () => {
                          await setSharedData({ knowledgeId: item._id });
                          handleknowledgeBaseList("knowledgeBaseList");
                        }}
                      >
                        <td>{index}</td>
                        <td>{item.name}</td>
                        <td>
                          {/* <button>Delete</button> */}
                          <Icon className="Tabledelete-icon" icon="material-symbols-light:delete-outline" color="#de3434" onClick={() => handleTableDelete(index)} />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          )}
          {/* Tabel */}
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default Newknowledge;
